import "./extend/object.js";

window.jSelect = function(selector, settings) {

   let parent = this;

   let jSelect = {
      create: function() {
         let root = parent instanceof HTMLElement ? parent : document;
         let defaults = {
            options: [],
            classes: []
         };

         let set = Object.extend(true, defaults, settings);
         this.parent = root.querySelector(selector);
         if (!this.parent) return null;
         if (this.parent.classList.contains('jSelect')) {
            this.select = this.parent.firstChild;
            return;
         }

         this.parent.addClass('jSelect');
         this.select = document.createElement('select', set.classes);
         this.parent.appendChild(this.select);

      },
      setOptions: function(options) {
         this.select.innerHTML = options.map(item => { return `<option value="${item.value}"${item.selected ? " selected" : ""}>${item.title}</option>` }).join('');
         return this;
      }
   };

   jSelect.create();

   return jSelect;

};

if (!HTMLElement.jSelect) {
   HTMLElement.prototype.jSelect = jSelect;
}
